
<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{sTituloGrid}}</span>
      </v-col>
    </v-row>
    <v-row class="no-gutters">
    <v-col md="12" sm="12" class="pa-0 ma-0">
      <grid ref="GridPrincipal"
        v-if="this.$store.state.token!=''"
        :key="nRefresGrid"
        :tabla="sTablaName"
        :bActiveFilter="true"
        :bActiveExport="true"
        :bSingleSelect="true"
        :bShowSelect="false"
        :bMostrarImagenes="true"
        :sIdTable="sIdTable"
        :bShowMapDetails="false"
        :bActiveNew="false"
        altoTabla="75vh">
      </grid>
    </v-col>
    </v-row>
  </v-container>  

</template>

<script>
import grid from '@/components/Grid/Grid.vue'
import mxFunciones from '@/mixins/funciones.js'
export default {
  name:"TiemposPorDepartamento",
  components: {
    grid,
  },
  mixins: [mxFunciones],
  data() {
    return {
      nTabSelect : 0,
      sTablaName  : 'PQR_Historicos_requerimiento',
      sIdTable    : 'idHistoricoRequerimiento',
      nRefresGrid : 0,
      sTituloGrid: '',
      valorprueba:{dato:''}
    }
  },
  async mounted() {
    this.sTituloGrid = await this.getTitulo(this.sTablaName)
  },
  methods: {
  },
  watch: {
    nTabSelect(){
      this.nRefresGrid++
    }
  },
}
</script>

<style lang="scss" scoped>

</style>